<ng-container [formGroup]="parentForm">
  <ion-item class="benificiary-checkbox ion-no-padding" lines="none">
    <ion-checkbox
      formControlName="vaccine_consent"
      class="ion-margin-end"
      color="primary"
      (ionChange)="onCheckConsent($event)"
      [ngClass]="{
        'checkbox-required': parentForm.get('vaccine_consent')?.errors?.required
      }"
    ></ion-checkbox>
    <ion-label
      class="no-ellipse-checkbox-label no-whitespace"
      [ngClass]="{
        'checkbox-required':
          parentForm.get('vaccine_consent')?.touched &&
          parentForm.get('vaccine_consent')?.errors?.required
      }"
      ><i
        ><b>{{ "Consent Notice..." | translate }}</b></i
      >
      <a
        (click)="openBottomSheet()"
        class="view-more concen-btn"
        style="text-decoration: none; font-weight: normal; cursor: pointer"
        >{{ "Read More" | translate }}</a
      >
    </ion-label>
  </ion-item>
  <ion-item
    *ngIf="showHardCopyTxt"
    class="consent-msg d-flex ion-align-items-center"
    lines="none"
  >
    <ion-checkbox
      formControlName="consent_otp_registration"
      class="ion-margin-end"
      color="primary"
      [ngClass]="{
        'checkbox-required': parentForm.get('consent_otp_registration')?.errors
          ?.required
      }"
    ></ion-checkbox>
    <ion-icon name="information-circle"></ion-icon>
    <ion-label>
      {{
        "Hard copy of same consent would also be placed for signature of parent in case internet is not working."
          | translate
      }}
    </ion-label>
  </ion-item>
</ng-container>
